<template>
  <div style="padding: 5px" class="equipmentGroup">
    <div style="display: flex;justify-content: space-between;align-items: center;margin: 10px 30px 10px 10px;">
      <div style="font-size: 20px">{{ $t('station.title') }}</div>
      <div>
        <a-space>
          <a-button type="primary" @click="handleSearch" v-if="authorities.find(a => a.code === 'device:manage:device:group:query')">{{ $t('buttons.search') }}</a-button>
          <a-button type="primary" @click="toInsertView" v-if="authorities.find(a => a.code === 'device:manage:device:group:insert')">{{ $t('buttons.add') }}</a-button>
          <!-- <a-button type="danger" @click="removeDeviceGroup">删除</a-button> -->
        </a-space>
      </div>
    </div>
    <a-table
      :columns="columns"
      :data-source="list"
      :loading="loading"
      :scroll="scroll"
      :row-key="record => record.id"
      :pagination="pagination"
      @change="onChange"
    >
      <template v-slot:name="text, record">
        <a href="javascript:void(0)" @click="$router.push({ path: '/preview', query: { id: record.id, stationCode: record.code, customerId: record.customerId } })" type="link"><text-highlight :queries="[highLightInfo.name]">{{text}}</text-highlight></a>
      </template>
      <template v-slot:enabled="text, record">
        <a-switch @change="showConfirm(record)" :checked-children="$t('station.enableN')" :un-checked-children="$t('station.enableY')" :checked="record.enabled" />
      </template>
      <template v-slot:code="text">
        <text-highlight :queries="[highLightInfo.code]">{{text}}</text-highlight>
      </template>
      <template v-slot:company="text, record">
        <a v-if="ca.find(a => a.code === 'customer:update')" @click.stop="$router.push({ path: '/customer/detail', query: { id: record.customerId } })"><text-highlight :queries="highLightInfo.company">{{ text }}</text-highlight></a>
        <text-highlight v-else :queries="highLightInfo.company">{{ text }}</text-highlight>
      </template>
      <template v-slot:organizations="text">
        <text-highlight :queries="[highLightInfo['organizations.name']]">{{text}}</text-highlight>
      </template>
      <template v-slot:remark="text">
        <text-highlight :queries="[highLightInfo.remark]">{{text}}</text-highlight>
      </template>
      <template v-slot:createdAt="text, record">
        {{ moment(record.createdAt).format('YYYY-MM-DD HH:mm') }}
      </template>
      <template v-slot:updatedAt="text, record">
        {{ moment(record.updatedAt).format('YYYY-MM-DD HH:mm') }}
      </template>
      <template v-slot:operation="text, record">
        <a-space>
          <a-button style="padding-left: 0; padding-right: 0; margin-right: 0" type="link" @click="onEdit(record)" v-if="authorities.find(a => a.code === 'device:manage:device:group:update')">{{ $t('buttons.edit') }}</a-button>
          <a-popconfirm
            style="padding: 0"
            :title="$t('messages.ctrd')"
            :ok-text="$t('common.okText')"
            :cancel-text="$t('common.cancelText')"
            @confirm="removeDeviceGroup(record.id)"
          >
            <a-button type="link" v-if="authorities.find(a => a.code === 'device:manage:device:group:delete')">{{ $t('buttons.delete') }}</a-button>
          </a-popconfirm>
          <a-button v-if="authorities.find(a => a.code === 'device:manage:device:group:zt:save')" style="padding: 0" type="link" @click="$router.push({ path: '/equipment/group/detail', query: { id: record.id, code: record.stationCode } })">{{ $t('station.configuration') }}{{ $t('buttons.edit') }}</a-button>
          <a-button :loading="record.loading" style="padding: 0" type="link" v-if="authorities.find(a => a.code === 'device:group:expression:query')"  @click="showExpressionModal(record)">{{ $t('station.pm') }}</a-button>
          <a-button :loading="record.SDLoading" style="padding: 0" type="link" v-if="authorities.find(a => a.code === 'device:group:expression:query')" @click="showSDExpressionModal(record)">{{ $t('station.selfDefinedParameters') }}</a-button>
        </a-space>
      </template>
    </a-table>
    <a-modal v-model="visible" :title="$t('station.calculationSetting')" :width="1200" :afterClose="clearExpression">
      <template slot="footer">
        <a-button :loading="isRemoving" key="custom" type="danger" style="float: left" @click="removeE" :disabled="!expressionStr.id">{{ $t('station.deleteConfiguration') }}</a-button>
        <a-input @change="expression[selectedE[0]].done = true" style="width: 70%; margin-right: 5%" v-model="expressionStr[selectedE[0]]" />
        <a-space>
          <a-button key="back" @click="visible = false">
            {{ $t('common.cancelText') }}
          </a-button>
          <a-button :loading="isSaving" key="submit" type="primary" @click="saveE">
            {{ $t('buttons.save') }}
          </a-button>
        </a-space>
      </template>
      <div class="expression w-100" style="height: 600px">
        <div>
          <h3 style="height: 25px">
            {{ $t('station.parameters') }}
          </h3>
          <a-menu
            style="width: 80%; border: none"
            mode="inline"
            v-model="selectedE"
          >
            <a-menu-item v-for="(v, k) in expression" :key="k" @click="selectE(k)">
              {{ v[lang] }}
            </a-menu-item>
            <a-button :disabled="!this.selectedE.length" type="primary" style="margin-left: 20px;" @click="setExpression">{{ $t('station.setExpression') }}</a-button>
          </a-menu>
        </div>
        <div style="margin-right: 20px" :key="this.expressionStr.groupId">
          <header>
            <h3 style="width: 90%; display: flex; justify-content: space-between; position: relative">
              {{ $t('device.title') }}
              <a-checkbox style="position: absolute; top: 50%; right: 0; transform: translateY(-50%)" @change="change($event, 'isDeviceCached', 'devices', 'totalDevices', 'isDeviceCached', deviceSP)">{{ $t('station.seDevice') }}</a-checkbox>
            </h3>
            <a-input :placeholder="$t('station.searchDeviceCodeOrName')" style="width: 90%; margin-bottom: 10px" @keyup.enter="search('devices', 'totalDevices', 'isDeviceCached', deviceSP)" v-model="deviceSP">
              <a-icon type="search" slot="suffix" />
            </a-input>
          </header>
          <div v-show="isDeviceLoading" style="width: 90%; height: 87%; position: relative">
            <a-spin style="position: absolute; top: 50%; left: 50%; transform: translateX(-50%)" />
          </div>
          <a-menu
            style="width: 90%; border: none; height: 87%; overflow-y: auto;"
            mode="inline"
            v-show="!isDeviceLoading"
            v-model="selectedD"
          >
            <a-menu-item v-for="(d, i) in devices" :key="d.code" @click="selectD(d, i)">
              <a-checkbox v-model="d.selected" @click.stop @change="changeExpression(d, 'd')" style="margin-left: -6px; margin-right: 6px;" />{{ d.name }}
            </a-menu-item>
          </a-menu>
        </div>
        <div :key="this.expressionStr.groupId + 1">
          <header>
            <h3 style="width: 90%; display: flex; justify-content: space-between;  position: relative">
              {{ $t('modification.points') }}
              <a-checkbox style="position: absolute; top: 50%; right: 0; transform: translateY(-50%)" @change="change($event, 'isPointsCached', 'points', 'totalPoints', 'isPointsCached', pointSP)">{{ $t('station.sePoints') }}</a-checkbox>
            </h3>
            <a-input :placeholder="$t('station.searchPointCodeOrName')" style="width: 90%; margin-bottom: 10px" @keyup.enter="search('points', 'totalPoints', 'isPointsCached', pointSP)" v-model="pointSP">
              <a-icon type="search" slot="suffix" />
            </a-input>
          </header>
          <div v-show="isPLoading" style="width: 90%; height: 80%; position: relative">
            <a-spin style="position: absolute; top: 50%; left: 50%; transform: translateX(-50%); height: unset" />
          </div>
          <ul class="points" v-show="!isPLoading">
            <li v-for="p in points" :key="p.code">
              <a-checkbox style="margin-right: 6px" v-model="p.selected" @change="changeExpression(p, 'p')">{{ p[lang] }}({{ p.unit }})</a-checkbox>
            </li>
          </ul>
        </div>
      </div>
    </a-modal>
    <a-modal v-model="SDEVisible" :title="$t('station.calculationSetting')" :width="1200" :afterClose="clearSelfDefinedExpression">
      <template slot="footer">
        <a-input style="width: 80%; margin-right: 5%" v-model="selfDefinedExpressionStr" />
        <a-space>
          <a-button key="back" @click="SDEVisible = false">
            {{ $t('common.cancelText') }}
          </a-button>
          <a-button :loading="isSDSaving" key="submit" type="primary" @click="saveSDE">
            {{ $t('buttons.save') }}
          </a-button>
        </a-space>
      </template>
      <div class="expression w-100" style="height: 600px">
        <div>
          <h3 style="height: 25px">
            {{ $t('station.parameters') }}
            <a-button type="primary" style="margin-left: 15px;" @click="showSDExpressionFormModal(false)">{{ $t('buttons.add') }}</a-button>
            <a-button :disabled="!selectedSDE.length" type="primary" style="margin-left: 15px;" @click="showSDExpressionFormModal(true)">{{ $t('buttons.edit') }}</a-button>
            <a-button :disabled="!selectedSDE.length" type="danger" style="margin-left: 15px;" @click="deleteSelfDefinedExpression">{{ $t('buttons.delete') }}</a-button>
          </h3>
          <a-menu
            style="width: 80%; border: none; margin-top: 15px"
            mode="inline"
            v-model="selectedSDE"
          >
            <a-menu-item v-for="s in selfDefinedExpressionList" :key="s.id" @click="selectSDE(s)">
              {{ s.paramName }}
            </a-menu-item>
            <a-button :disabled="!this.selectedSDE.length" type="primary" style="margin-left: 20px;" @click="setSDExpression">{{ $t('station.setExpression') }}</a-button>
          </a-menu>
        </div>
        <div style="margin-right: 20px" :key="this.SDEForm.groupId">
          <header>
            <h3 style="width: 90%; display: flex; justify-content: space-between; position: relative">
              {{ $t('device.title') }}
              <a-checkbox style="position: absolute; top: 50%; right: 0; transform: translateY(-50%)" @change="change($event, 'isDeviceCached', 'devices', 'totalDevices', 'isDeviceCached', deviceSP)">{{ $t('station.seDevice') }}</a-checkbox>
            </h3>
            <a-input :placeholder="$t('station.searchDeviceCodeOrName')" style="width: 90%; margin-bottom: 10px" @keyup.enter="search('devices', 'totalDevices', 'isDeviceCached', deviceSP)" v-model="deviceSP">
              <a-icon type="search" slot="suffix" />
            </a-input>
          </header>
          <!-- <div v-show="isDeviceLoading" style="width: 90%; height: 87%; position: relative">
            <a-spin style="position: absolute; top: 50%; left: 50%; transform: translateX(-50%)" />
          </div> -->
          <a-menu
            style="width: 90%; border: none; height: 87%; overflow-y: auto;"
            mode="inline"
            v-model="selectedSDD"
          >
            <a-menu-item v-for="(d, i) in devices" :key="d.code" @click="selectSDD(d, i)">
              <a-checkbox v-model="d.selected" @click.stop @change="changeSDExpression(d, 'd')" style="margin-left: -6px; margin-right: 6px;" />{{ d.name }}
            </a-menu-item>
          </a-menu>
        </div>
        <div>
          <header>
            <h3 style="width: 90%; display: flex; justify-content: space-between;  position: relative">
              {{ $t('modification.points') }}
              <a-checkbox v-model="isPointsCached" style="position: absolute; top: 50%; right: 0; transform: translateY(-50%)" @change="change($event, 'isPointsCached', 'points', 'totalPoints', 'isPointsCached', pointSP)">{{ $t('station.sePoints') }}</a-checkbox>
            </h3>
            <a-input :placeholder="$t('station.searchPointCodeOrName')" style="width: 90%; margin-bottom: 10px" @keyup.enter="search('points', 'totalPoints', 'isPointsCached', pointSP)" v-model="pointSP">
              <a-icon type="search" slot="suffix" />
            </a-input>
          </header>
          <!-- <div v-show="isPLoading" style="width: 90%; height: 80%; position: relative">
            <a-spin style="position: absolute; top: 50%; left: 50%; transform: translateX(-50%); height: unset" />
          </div> -->
          <ul class="points">
            <li v-for="p in points" :key="p.code">
              <a-checkbox style="margin-right: 6px" v-model="p.selected" @change="changeSDExpression(p, 'p')">{{ p[lang] }}({{ p.unit }})</a-checkbox>
            </li>
          </ul>
        </div>
      </div>
    </a-modal>
    <a-modal v-model="SDExpressionFormVisible" :title="$t('station.paramsSetting')" @cancel="handleExpressionFormModalCancel" @ok="submitSDExpression" :afterClose="clearSDExpressionForm" :confirmLoading="isAddingSDExpressionForm">
      <a-form-model ref="SDEForm" :model="SDEForm" :rules="SDERules" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }" style="padding-right: 10px;">
        <a-form-model-item :label="$t('station.paramCode')" prop="paramCode">
          <a-input v-model="SDEForm.paramCode" />
        </a-form-model-item>
        <a-form-model-item :label="$t('station.paramName')" prop="paramName">
          <a-input v-model="SDEForm.paramName" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'
import { deviceColumns } from './data'
import { removeDeviceGroup, searchGroupList, getDeviceGroup, updateDeviceGroup, getExpression, addExpression, updateExpression, deletExpression, getSelfDefinedExpression, insertSelfDefinedExpression, updateSelfDefinedExpression, deleteSelfDefinedExpression } from '@/api/device'
import { deviceApi } from '@/api/station'
import { getProtocol } from '@/api/protocol'
import DeviceModal from '@/views/EquipmentManager/EquipmentGroup/components/DeviceModal'
import Tr from './components/Tr'
import TextHighlight from 'vue-text-highlight'

export default {
  name: 'index',
  components: { DeviceModal, Tr, TextHighlight },
  mounted () {
    this.getGroupList()
    this.globalClick(this.hideSelectOption)
      const ss = document.querySelectorAll('.equipmentGroup .ant-table-column-title > div span.icons')
      ss.forEach(i => {
        i.addEventListener('click', () => {
          let c = ''
          switch (i.classList[1]) {
            case 'ASC':
              c = 'DESC'
              break;
            case 'DESC':
              c = 'unset'
              break;
            case 'unset':
              c = 'ASC'
              break;
            default:
              break;
          }
          i.classList.remove(i.classList[1])
          i.classList.add(c)
          const ii = document.querySelectorAll('.equipmentGroup .ant-table-column-title > div span.icons:not(.unset)')
          const sort = Array.from(ii).map(item => {
            const index = +item.dataset['index']
            console.log(item.classList);
            return {
              field: this.columns[index].key,
              value: item.classList[1]
            }
          })
          this.queryParams.sort = sort
          this.getGroupList(this.pagination.current, this.pagination.pageSize)
        })
      })
      const ips = document.querySelectorAll('.username .ant-input')
      ips.forEach(ip => {
        ip.addEventListener('keyup', ({ key, target }) => {
          // console.log(key, target.value.trim())
          if (key === 'Enter') {
            target.value = target.value.trim()
            // target.value.trim() && this.handleSearch()
            this.handleSearch()
          }
        })
        ip.addEventListener('blur', ({ target }) => {
          target.value = target.value.trim()
        })
      })
      this.s = document.querySelector('body')
      this.s.addEventListener('click', this.handleSelect)
      this.setScrollX()
  },
  data () {
    return {
      highLightInfo: {
        code: '',
        name: '',
        company: '',
        'organizations.name': '',
        remark: ''
      },
      ca: [],
      columns: [
        {
          title: () => (<div>{this.$t('station.code')}<span class="icons unset" style="cursor: pointer;" data-index="0"><a-icon type="caret-up" /><a-icon type="caret-down" /></span><a-input allow-clear class="username" type="text" data-index="0" /></div>),
          dataIndex: 'code',
          width: 150,
          key: 'code',
          scopedSlots: {
            customRender: 'code'
          }
        },
        {
          title: () => (<div>{this.$t('station.name')}<span class="icons unset" style="cursor: pointer;" data-index="1"><a-icon type="caret-up" /><a-icon type="caret-down" /></span><a-input allow-clear type="text" class="username" data-index="1" /></div>),
          dataIndex: 'name',
          key: 'name',
          width: 190,
          scopedSlots: {
            customRender: 'name'
          }
        },
        {
          title: () => (<div>{this.$t('common.customer')}<span class="icons unset" style="cursor: pointer;" data-index="2"><a-icon type="caret-up" /><a-icon type="caret-down" /></span><a-input allow-clear type="text" class="username" data-index="2" /></div>),
          dataIndex: 'company',
          key: 'company',
          width: 260,
          scopedSlots: {
            customRender: 'company'
          }
        },
        {
          title: () => (<div>{this.$t('station.organization')}<span class="icons unset" style="cursor: pointer;" data-index="3"><a-icon type="caret-up" /><a-icon type="caret-down" /></span><a-input allow-clear type="text" class="username" data-index="3" /></div>),
          dataIndex: 'organizations',
          key: 'organizations.name',
          scopedSlots: {
            customRender: 'organizations'
          },
          width: 180
        },
        // {
        //   title: () => (<div>{this.$t('station.remark')}<span class="icons unset" style="cursor: pointer;" data-index="4"><a-icon type="caret-up" /><a-icon type="caret-down" /></span><a-input allow-clear type="text" class="username" data-index="4" /></div>),
        //   dataIndex: 'remark',
        //   key: 'remark',
        //   width: 100,
        //   scopedSlots: {
        //     customRender: 'remark'
        //   }
        // },
        {
          title: () => (<div>{this.$t('station.enable')}<br /><a-select class="username" default-value="true" data-index="3" style="width: 80px; margin-left: -5px"><a-select-option value="true">{ this.$t('device.no') }</a-select-option><a-select-option value="false">{ this.$t('device.yes') }</a-select-option></a-select></div>),
          dataIndex: 'enabled',
          key: 'enabled',
          width: 110,
          scopedSlots: {
            customRender: 'enabled'
          }
        },
        {
          title: () => <div>{this.$t('common.createdAt')}<span class="icons unset" style="cursor: pointer; right: -32px" data-index="5"><a-icon type="caret-up" /><a-icon type="caret-down" /></span></div>,
          dataIndex: 'createdAt',
          key: 'createdAt',
          width: 160,
          scopedSlots: { customRender: 'createdAt' }
        },
        {
          title: () => <div>{this.$t('common.createdBy')}</div>,
          dataIndex: 'createdUser',
          key: 'createdUser',
          width: 120,
          scopedSlots: { customRender: 'createdUser' }
        },
        {
          title: () => (<div>{this.$t('common.updatedAt')}<span class="icons DESC" style="cursor: pointer; right: -32px" data-index="7"><a-icon type="caret-up" /><a-icon type="caret-down" /></span></div>),
          dataIndex: 'updatedAt',
          key: 'updatedAt',
          width: 160,
          scopedSlots: { customRender: 'updatedAt' }
        },
        {
          title: () => <div>{this.$t('common.updatedBy')}</div>,
          dataIndex: 'updatedUser',
          key: 'updatedUser',
          width: 120,
          scopedSlots: { customRender: 'updatedUser' }
        },
        {
          title: () => this.$t('common.operation'),
          key: 'operation',
          align: 'center',
          scopedSlots: { customRender: 'operation' },
          fixed: 'right'
        }
      ],
      deviceColumns,
      list: [],
      rowSelection: {
        selectedRowKeys: [],
        onChange: (selectedRowKeys, selectedRows) => {
          this.rowSelection.selectedRowKeys = selectedRowKeys
        }
      },
      chartShow: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30', '40', '50']
      },
      isRemoving: false,
      searchInfo: {
        text: {
          stationCode: '',
          stationName: '',
          companyName: ''
        },
        columns: {
          stationCode: false,
          stationName: false,
          companyName: false
        }
      },
      sortInfo: [],
      deviceModalVisible: false,
      queryParams: {
        query: [],
        filter: [
          {
            field: 'enabled',
            value: true
          }
        ],
        sort: [
          {
            field: 'updatedAt',
            value: 'DESC'
          }
        ]
      },
      loading: true,
      authorities: [],
      visible: false,
      isPointsCached: false,
      devices: [],
      selectedD: [],
      expression: {
        cumulativeGas: {
          zh: '空压站累计供气总量(Nm³)',
          en: 'Total gas of air compressor station (Nm³)'
        },
        instantaneousGas: {
          zh: '瞬时供气总量(Nm³/min)',
          en: 'Instantaneous gas supply (Nm³/min)'
        },
        cumulativePower: {
          zh: '空压站累计总电量(kWh)',
          en: 'Total accumulated power of air compressor station (kWh)'
        },
        instantaneousPower: {
          zh: '瞬时总功率(kW)',
          en: 'Instantaneous total Power (kW)'
        },
        outputPres: {
          zh: '站房出口压力(MPa)',
          en: 'Station outlet pressure (MPa)'
        },
        outputDewPoint: {
          zh: '站房出口露点(℃)',
          en: 'Station exit dew point (℃)'
        },
        temperature: {
          zh: '现场环境温度(℃)',
          en: 'Site ambient temperature (℃)'
        },
        humidity: {
          zh: '现场环境湿度(%RH)',
          en: 'Site Humidity (%RH)'
        }
      },
      expressionStr: {},
      selectedE: [],
      points: [],
      isPLoading: false,
      deviceSP: '',
      pointSP: '',
      isDeviceLoading: false,
      isSaving: false,
      scroll: {
        x: false
      },
      SDEVisible: false,
      selfDefinedExpressionList: [],
      selfDefinedExpressionStr: '',
      isSDSaving: false,
      SDExpressionFormVisible: false,
      SDEForm: {
        groupId: '',
        groupCode: '',
        paramName: '',
        paramCode: '',
        expression: ''
      },
      SDERules: {},
      isAddingSDExpressionForm: false,
      selectedSDE: [],
      selectedSDD: []
    }
  },
  computed: {
    lang() {
      return this.$store.state.lang
    }
  },
  watch: {
    lang() {
      this.setScrollX()
      this.translate()
    }
  },
  created() {
    this.translate()
  },
  activated() {
    const a = JSON.parse(sessionStorage.getItem('authorities'))
    if (a?.length) {
      this.authorities = a
    } else {
      this.authorities = this.getAuthorities(this.$route.path)
    }
    this.ca = this.getAuthorities('/customer')
    this.s = document.querySelector('body')
    this.s.addEventListener('click', this.handleSelect)
  },
  deactivated() {
    this.s = document.querySelector('body')
    this.s.removeEventListener('click', this.handleSelect)
  },
  methods: {
    translate() {
      const lang = this.$store.state.lang
      if (lang === 'zh') {
        this.SDERules = {
          paramCode: [
            {
              required: true,
              message: '请输入参数编号',
              trigger: 'blur'
            }
          ],
          paramName: [
            {
              required: true,
              message: '请输入参数名称',
              trigger: 'blur'
            }
          ]
        }
      }
      if (lang === 'en') {
        this.SDERules = {
          paramCode: [
            {
              required: true,
              message: 'Please enter the param code',
              trigger: 'blur'
            }
          ],
          paramName: [
            {
              required: true,
              message: 'Please enter the param name',
              trigger: 'blur'
            }
          ]
        }
      }
    },
    setScrollX() {
      const width = window.innerWidth
      if (this.lang === 'en') {
        this.scroll.x = 1647
        return
      }
      if (width < 1600) {
        this.scroll.x = 1350
      } else if (width < 1900) {
        this.scroll.x = 1647
      } else {
        this.scroll.x = 1700
      }
    },
    hideSelectOption (e) {
      // this.pressureShow = false
      // this.flowShow = false
      const targetName = ['LI', 'A', 'TH']
      // const className = ['']
      // if (e.target.tagName === 'LI' || e.target.tagName === 'A' || e.target.tagName === 'TH') {
      if (e.target._prevClass === 'dataMenu' || targetName.includes(e.target.tagName)) {
        return undefined
      } else {
        this.pressureShow = false
        this.flowShow = false
      }
    },
    handleSearch() {
      this.pagination.current = 1
      const ips = document.querySelectorAll('.username .ant-input')
      this.queryParams.query = []
      ips.forEach(ip => {
        if (ip.value.trim()) {
          this.queryParams.query.push({
            field: this.columns[+ip.dataset['index']].key,
            value: ip.value
          })
          this.highLightInfo[this.columns[+ip.dataset['index']].key] = ip.value
        } else {
          this.highLightInfo[this.columns[+ip.dataset['index']].key] = ''
        }
      })
      this.getGroupList(this.pagination.current, this.pagination.pageSize)
    },
    moment,
    getGroupList (page = 1, size = 10) {
      this.loading = true
      searchGroupList(page, size, this.queryParams).then(({ data }) => {
        this.list = data.records.map(r => {
          let o = {}
          r.organizations.forEach(or => {
            o[or.name] = or.name
          })
          o = Object.keys(o).join('，')
          r.organizations = o
          return r
        })
        this.pagination.current = data.current
        this.pagination.pageSize = data.size
        this.pagination.total = data.total
      }).catch((e) => {
        console.log(e);
        // this.$message.error("请求失败")
      }).finally(() => {
        this.loading = false
      })
    },
    async onChange (pagination) {
      this.pagination = pagination
      this.getGroupList(pagination.current, pagination.pageSize)
    },
    toInsertView () {
      this.$router.push({ path: '/equipment/group/submit' })
    },
    onEdit (record) {
      this.$store.commit("setStationInfo", record)
      this.$router.push("/equipment/group/submit")
    },
    async showExpressionModal(record) {
      record.loading = true
      try {
        const { data } = await getDeviceGroup(record.id)
        this.totalDevices = data.devices
        const res = await getExpression(record.id)
        this.expressionStr = res.data
        this.expressionStr.groupId = record.id
        for (let e in this.expression) {
          this.expressionStr[e] = this.expressionStr[e] || ''
          const a = []
          const regex = /\${(.*?)}/g
          let match
          while ((match = regex.exec(this.expressionStr[e])) !== null) {
            a.push(match[1])
          }
          console.log(a)
          a.forEach(q => {
            if (!q) return
            q = q.split('.')
            let d = q[0]
            let p = q[1]
            if (!this.expression[e][d]) {
              this.expression[e][d] = {
                [p]: true
              }
            } else {
              this.expression[e][d][p] = true
            }
          })
        }
        this.visible = true
      } catch(e) {
        this.totalDevices = []
        console.log(e)
      } finally {
        record.loading = false
      }
    },
    removeDevice () {
      const list = this.groupDrawer.deviceList.filter(item => this.groupDrawer.rowSelection.selectedRowKeys.indexOf(item.id) !== -1)
      list.forEach(item => {
        const index = this.groupDrawer.deviceList.indexOf(item)
        this.groupDrawer.deviceList.splice(index, 1)
      })
    },
    updateGroup () {
      console.log(this.selectedItem)
      // const a = [this.selectedCharts.includes('preview'), this.selectedCharts.includes('fullscreen')]
      const stationForm = {
        id: this.groupDrawer.record.id,
        stationCode: this.groupDrawer.record.stationCode,
        stationName: this.groupDrawer.record.stationName,
        customerId: this.groupDrawer.record.customerId,
        content: this.groupDrawer.record.content,
        companyName: this.groupDrawer.record.companyName,
        remark: this.groupDrawer.record.remark,
        devices: this.groupDrawer.deviceList,
        deviceCodes: JSON.stringify(this.groupDrawer.devicecodes),
        createdAt: this.groupDrawer.createdAt,
        createdBy: this.groupDrawer.createdBy,
        electricPrice: +this.groupDrawer.record.electricPrice,
        flow: this.flow?.trim(),
        gasElectricRatio: +this.groupDrawer.record.gasElectricRatio,
        pressure: this.pressure?.trim(),
        interval: +this.groupDrawer.record.interval,
        chart: JSON.stringify(this.selectedItem)
      }
      deviceGroupApi.save(stationForm).then(({ message }) => {
        this.$message.success(message)
        this.groupDrawer.visible = false
      }).catch(() => {
        // this.$message.error("请求失败")
      })
    },
    async handleReset (clearFilters, dataIndex) {
      clearFilters()
      this.searchInfo.text[dataIndex] = ''
      this.searchInfo.columns[dataIndex] = false
      try {
        const { data } = await deviceApi.queryAndSortDeviceGroup(this.pagination.current, this.pagination.pageSize, {
          model: this.searchInfo.text,
          sort: this.sortInfo
        })
        this.list = data.records
        this.pagination.current = data.current
        this.pagination.pageSize = data.size
        this.pagination.total = data.total
      } catch {
        // this.$message.error("请求失败")
      }
    },
    // removeDeviceGroup () {
    //   deviceGroupApi.remove(this.rowSelection.selectedRowKeys).then(({ message }) => {
    //     this.$message.success(message)
    //   }).catch(() => {
    //     // this.$message.error("请求失败")
    //   })
    // },
    async removeDeviceGroup(id) {
      try {
        const { message } = await removeDeviceGroup(id)
        this.$message.success(message)
        this.getGroupList()
      } catch {}
    },
    async showConfirm(record) {
      this.$confirm({
        title: this.$t('messages.cts'),
        content: this.$t('messages.confirmS'),
        onOk: async () => {
          record.enabled = !record.enabled
          const { data } = await getDeviceGroup(record.id)
          data.enabled = record.enabled
          this.loading = true
          updateDeviceGroup(data).then(({ message }) => {
            this.$message.success(message)
            this.getGroupList(this.pagination.current, this.pagination.pageSize)
          }).catch((e) => {
            console.log(e);
            // this.$message.error("请求失败")
          })
        },
        onCancel() {
          record.enabled = record.enabled
        }
      })
    },
    handleSelect(e) {
      if(e.target.classList[1] === 'ant-select-dropdown-menu-item-selected') {
        if (['正常', '已拆除'].includes(e.target.innerText)) {
          this.queryParams.filter[0].value = e.target.innerText === '正常'
          this.pagination.current = 1
          this.onChange(this.pagination)
        }
      }
    },
    selectE(k) {
      this.isDeviceLoading = true
      this.selectedD = []
      this.selectedDeviceIndex = -1
      this.deviceSP = ''
      this.pointSP = ''
      this.devices = this.totalDevices.map(t => {
        t.selected = !!this.expression[k][t.code]
        return t
      })
      if (this.isDeviceCached) {
        this.devices = this.devices.filter(d => d.selected)
      }
      this.points = this.totalPoints = []
      this.isDeviceLoading = false
    },
    async selectD(d, i) {
      if (i === this.selectedDeviceIndex) return
      this.isPLoading = true
      this.selectedDeviceIndex = i
      try {
        const { data } = await getProtocol(d.protocolCode)
        this.points = this.totalPoints = data.points.filter(d => d.dataWrite !== 2).map(p => {
          if (d.selected) {
            p.selected = !!this.expression[this.selectedE[0]][d.code][p.code]
          };
          (p.details || []).forEach(d => {
            if (d.locale === 'zh-CN') {
              p.zh = d.name
            }
            if (d.locale === 'en-US') {
              p.en = d.name
            }
          })
          if (!p.zh) {
            p.zh = p.name
          }
          if (!p.en) {
            p.en = p.zh
          }
          return p
        })
        if (this.isPointsCached) {
          this.points = this.points.filter(p => p.selected)
        }
      } catch(e) {
        console.log(e)
        this.totalPoints = []
      } finally {
        this.isPLoading = false
      }
    },
    async selectSDD(d, i) {
      if (i === this.selectedDeviceIndex) return
      this.selectedDeviceIndex = i
      try {
        const { data } = await getProtocol(d.protocolCode)
        const expression = this.selfDefinedExpressionList.find(s => s.id === this.selectedSDE[0]).deviceAndPointsRecord
        this.points = this.totalPoints = data.points.filter(d => d.dataWrite !== 2).map(p => {
          if (d.selected) {
            p.selected = !!expression[d.code][p.code]
          };
          (p.details || []).forEach(d => {
            if (d.locale === 'zh-CN') {
              p.zh = d.name
            }
            if (d.locale === 'en-US') {
              p.en = d.name
            }
          })
          if (!p.zh) {
            p.zh = p.name
          }
          if (!p.en) {
            p.en = p.zh
          }
          return p
        })
        if (this.isPointsCached) {
          this.points = this.points.filter(p => p.selected)
        }
      } catch(e) {
        console.log(e)
        this.totalPoints = []
      }
    },
    search(target, origin, flag, params) {
      if (!this[origin]) {
        return
      }
      this[target] = this[origin].filter(d => {
        return (this[flag] ? d.selected : true) && (d.name.includes(params) || d.code.toUpperCase().includes(params.toUpperCase()))
      })
    },
    change(e, flag, ...args) {
      this[flag] = e.target.checked
      this.search(...args)
    },
    changeExpression(d, type) {
      console.log(d.selected);
      if (d.selected) {
        if (type === 'd') {
          this.expression[this.selectedE[0]][d.code] = {}
        }
        if (type === 'p') {
          this.selectD[0] = this.devices[this.selectedDeviceIndex].code
          console.log(this.selectD[0])
          this.devices[this.selectedDeviceIndex].selected = true
          const a = this.expression[this.selectedE[0]][this.selectD[0]]
          if (!a) {
            this.expression[this.selectedE[0]][this.selectD[0]] = {
              [d.code]: true
            }
          } else {
            this.expression[this.selectedE[0]][this.selectD[0]][d.code] = true
          }
        }
      } else {
        if (type === 'd') {
          delete this.expression[this.selectedE[0]][d.code]
          this.points.forEach(p => p.selected = false)
        }
        if (type === 'p') {
          delete this.expression[this.selectedE[0]][this.selectD[0]][d.code]
        }
      }
      this.$forceUpdate()
      console.log(this.expression)
    },
    changeSDExpression(d, type) {
      const expression = this.selfDefinedExpressionList.find(s => s.id === this.selectedSDE[0]).deviceAndPointsRecord
      if (d.selected) {
        if (type === 'd') {
          expression[d.code] = {}
        }
        if (type === 'p') {
          this.selectD[0] = this.devices[this.selectedDeviceIndex].code
          this.devices[this.selectedDeviceIndex].selected = true
          const a = expression[this.selectD[0]]
          if (!a) {
            expression[this.selectD[0]] = {
              [d.code]: true
            }
          } else {
            expression[this.selectD[0]][d.code] = true
          }
        }
      } else {
        if (type === 'd') {
          delete expression[d.code]
          this.points.forEach(p => p.selected = false)
        }
        if (type === 'p') {
          delete expression[this.selectD[0]][d.code]
        }
      }
      this.$forceUpdate()
    },
    async saveE() {
      this.isSaving = true
      for (let e in this.expression) {
        if (this.expression[e].done) {
          continue
        }
        let q = []
        Object.keys(this.expression[e]).filter(k => k !== 'zh' && k !== 'en').forEach(d => {
          for (let p in this.expression[e][d]) {
            q.push('${' + d + '.' + p + '}')
          }
        })
        this.expressionStr[e] = q.join(' + ')
      }
      try {
        if (this.expressionStr.id) {
          const { message } = await updateExpression(this.expressionStr)
          this.$message.success(message)
        } else {
          const { message } = await addExpression(this.expressionStr)
          this.$message.success(message)
        }
        this.isSaving = false
        this.visible = false
      } catch(e) {
        console.log(e)
      } finally {
        this.isSaving = false
      }
    },
    async saveSDE() {
      this.isSDSaving = true
      try {
        const form = { ...this.SDEForm }
        form.id = this.selectedSDE[0]
        const e = this.selfDefinedExpressionList.find(s => s.id === this.selectedSDE[0])
        form.paramCode = e.paramCode
        form.paramName = e.paramName
        form.expression = this.selfDefinedExpressionStr
        const { message } = await updateSelfDefinedExpression(form)
        this.$message.success(message)
        this.SDEVisible = false
      } catch(e) {
        console.log(e)
      } finally {
        this.isSDSaving = false
      }
    },
    async removeE() {
      this.isRemoving = true
      try {
        const { message } = await deletExpression(this.expressionStr.id)
        this.$message.success(message)
        this.visible = false
        delete this.expressionStr.id
      } catch(e) {
        console.log(e)
      } finally {
        this.isRemoving = false
      }
    },
    clearExpression() {
      this.expressionStr = {}
      this.expression = {
        cumulativeGas: {
          zh: '空压站累计供气总量(Nm³)',
          en: 'Total gas of air compressor station (Nm³)'
        },
        instantaneousGas: {
          zh: '瞬时供气总量(Nm³/min)',
          en: 'Instantaneous gas supply (Nm³/min)'
        },
        cumulativePower: {
          zh: '空压站累计总电量(kWh)',
          en: 'Total accumulated power of air compressor station (kWh)'
        },
        instantaneousPower: {
          zh: '瞬时总功率(kW)',
          en: 'Instantaneous total Power (kW)'
        },
        outputPres: {
          zh: '站房出口压力(MPa)',
          en: 'Station outlet pressure (MPa)'
        },
        outputDewPoint: {
          zh: '站房出口露点(℃)',
          en: 'Station exit dew point (℃)'
        },
        temperature: {
          zh: '现场环境温度(℃)',
          en: 'Site ambient temperature (℃)'
        },
        humidity: {
          zh: '现场环境湿度(%RH)',
          en: 'Site Humidity (%RH)'
        }
      }
      this.devices = this.totalDevices = []
      this.points = this.totalPoints = []
      this.selectedE = []
      this.selectedD = []
      this.isDeviceCached = false
      this.isPointsCached = false
    },
    clearSelfDefinedExpression() {
      this.selfDefinedExpressionStr = ''
      this.selfDefinedExpressionList = []
      this.devices = this.totalDevices = []
      this.points = this.totalPoints = []
      this.selectedSDE = []
      this.selectedSDD = []
      this.isDeviceCached = false
      this.isPointsCached = false
    },
    setExpression() {
      let q = []
      let e = this.selectedE[0]
      console.log(e)
      Object.keys(this.expression[e]).filter(k => k !== 'zh' && k !== 'en').forEach(d => {
        for (let p in this.expression[e][d]) {
          q.push('${' + d + '.' + p + '}')
        }
      })
      this.expressionStr[e] = q.join(' + ')
      this.expression[e].done = true
    },
    setSDExpression() {
      let q = []
      let e = this.selectedSDE[0]
      const expression = this.selfDefinedExpressionList.find(s => s.id === e).deviceAndPointsRecord
      Object.keys(expression).forEach(d => {
        for (let p in expression[d]) {
          q.push('${' + d + '.' + p + '}')
        }
      })
      console.log(q, e)
      this.selfDefinedExpressionStr = q.join(' + ')
    },
    async showSDExpressionModal(r) {
      r.SDLoading = true
      try {
        this.SDEForm.groupId = r.id
        this.SDEForm.groupCode = r.code
        this.getSelfDefinedExpressionList()
        const o = await getDeviceGroup(r.id)
        this.totalDevices = o.data.devices
      } catch(e) {
        console.log(e)
      } finally {
        r.SDLoading = false
        this.SDEVisible = true
      }
    },
    selectSDE(s) {
      this.devices = this.totalDevices.map(t => {
        t.selected = !!s.deviceAndPointsRecord[t.code]
        return t
      })
      if (this.isDeviceCached) {
        this.devices = this.devices.filter(d => d.selected)
      }
      this.points = []
      this.selectedSDD = []
      this.selfDefinedExpressionStr = s.expression
      this.selectedDeviceIndex = -1
    },
    showSDExpressionFormModal(isEdit) {
      this.SDExpressionFormVisible = true
      if (isEdit) {
        const param = this.selfDefinedExpressionList.find(s => s.id === this.selectedSDE[0])
        this.SDEForm.paramCode = param.paramCode
        this.SDEForm.paramName = param.paramName
        this.SDEForm.expression = param.expression
        this.SDEForm.id = param.id
      }
    },
    handleExpressionFormModalCancel() {
      this.$refs.SDEForm.clearValidate()
    },
    clearSDExpressionForm() {
      this.SDEForm.paramName = ''
      this.SDEForm.paramCode = ''
      this.SDEForm.expression = ''
      this.isDeviceCached = false
      this.isPointsCached = false
    },
    submitSDExpression() {
      this.$refs.SDEForm.validate(async valid => {
        if (valid) {
          const form = { ...this.SDEForm }
          delete this.SDEForm.id
          this.isAddingSDExpressionForm = true
          try {
            if (form.id) {
              const { message } = await updateSelfDefinedExpression(form)
              this.$message.success(message)
            } else {
              const { message } = await insertSelfDefinedExpression(form)
              this.$message.success(message)
            }
            this.SDExpressionFormVisible = false
            this.getSelfDefinedExpressionList()
          } catch(e) {
            console.log(e)
          } finally {
            this.isAddingSDExpressionForm = false
          }
        }
      })
    },
    deleteSelfDefinedExpression() {
      this.$confirm({
        title: this.$t('messages.ctrd'),
        content: this.$t('common.sd'),
        onOk: async () => {
          try {
            const { message } = await deleteSelfDefinedExpression(this.selectedSDE[0])
            this.$message.success(message)
            this.getSelfDefinedExpressionList()
            this.selectedSDE = []
            this.selectedSDD = []
            this.devices = []
            this.points = []
            this.selfDefinedExpressionStr = ''
            this.clearSDExpressionForm()
          } catch (e) {
            console.log(e)
          }
        }
      })
    },
    async getSelfDefinedExpressionList() {
      try {
        const { data } = await getSelfDefinedExpression(this.SDEForm.groupId)
        this.selfDefinedExpressionList = data.map(s => {
          s.deviceAndPointsRecord = {}
          if (s.expression) {
            const a = []
            const regex = /\${(.*?)}/g
            let match
            while ((match = regex.exec(s.expression)) !== null) {
              a.push(match[1])
            }
            a.forEach(q => {
              if (!q) return
              q = q.split('.')
              let d = q[0]
              let p = q[1]
              if (!s.deviceAndPointsRecord[d]) {
                s.deviceAndPointsRecord[d] = {
                  [p]: true
                }
              } else {
                s.deviceAndPointsRecord[d][p] = true
              }
            })
          }
          return s
        })
      } catch(e) {
        console.log(e)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.row {
  margin-top: 5px;
}
.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}
.dataMenu {
  width: 100%;
  position: relative;
  border: 1px solid #ccc;
  margin-top: -5px;
  padding: 0 10px;
}
.dataMenu ul,
.dataMenu ul li {
  padding: 0;
  margin: 0;
}
.ant-table-column-title span {
  position: relative;
}
.ant-table-column-title .anticon-caret-up {
  position: absolute;
  top: -1px;
  right: -18px;
  font-size: 14px;
  color: #ccc;
}
.ant-table-column-title span.ASC .anticon-caret-up {
  color: #1890ff;
}
.ant-table-column-title span.DESC .anticon-caret-down {
  color: #1890ff;
}
.ant-table-column-title .anticon-caret-down {
  position: absolute;
  top: 8px;
  right: -18px;
  font-size: 14px;
  color: #ccc;
}
/deep/ .ant-table-tbody .ant-table-row:nth-child(2n) {
  background: rgb(250, 250, 250)
}
.ant-table-column-title div {
  position: relative;
}
.ant-table-column-title span {
  position: relative;
}
.ant-table-column-title .anticon-caret-up {
  position: absolute;
  top: -1px;
  right: -18px;
  font-size: 14px;
  color: #ccc;
}
.ant-table-column-title span.ASC .anticon-caret-up {
  color: #1890ff;
}
.ant-table-column-title span.icons {
  position: absolute;
  right: 18px;
}
.ant-table-column-title span.DESC .anticon-caret-down {
  color: #1890ff;
}
.ant-table-column-title .anticon-caret-down {
  position: absolute;
  top: 8px;
  right: -18px;
  font-size: 14px;
  color: #ccc;
}
.expression {
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
  div {
    flex: 1;
    height: 100%;
  }
  .points {
    width: 90%;
    list-style: none;
    padding-left: 24px;
    height: 87%;
    overflow-y: auto;
    li {
      height: 40px;
      line-height: 40px;
      cursor: pointer;
    }
  }
}
/deep/ .ant-menu-inline .ant-menu-item, .ant-menu-inline .ant-menu-submenu-title {
  width: unset;
}
</style>
